import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5c81d290"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "root"
};
const _hoisted_2 = {
  class: "mobile-header flex-row-center"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logo"
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "company-name"
}, "Waterboger", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-full"
}, null, -1));
const _hoisted_6 = {
  key: 0,
  class: "menu-list"
};
const _hoisted_7 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_clickOutSide = _resolveDirective("clickOutSide");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _hoisted_5, _createElementVNode("div", {
    class: "menu-btn flex-col",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.showMenu = !_ctx.showMenu)
  }, _toDisplayString(_ctx.$t('menu')), 1)]), _ctx.showMenu ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "menu-item",
      onClick: $event => _ctx.onClick(index)
    }, _toDisplayString(_ctx.$t(item.title)), 9, _hoisted_7);
  }), 128)), _createElementVNode("div", {
    class: "menu-item",
    onClick: _cache[1] || (_cache[1] =
    //@ts-ignore
    (...args) => _ctx.changeLanguage && _ctx.changeLanguage(...args))
  }, _toDisplayString(_ctx.$t('language')), 1)])), [[_directive_clickOutSide, _ctx.onClickOutSide]]) : _createCommentVNode("", true)]);
}